import React, { useEffect } from 'react';
import { Col, Container, Row, Card } from 'react-bootstrap';
import { FaExclamationTriangle, FaMoneyBillWave, FaClock, FaShieldAlt, FaCircle } from 'react-icons/fa';
import { COLORS } from '../constants/colors';

function TermsScreen() {
    const copper = COLORS.COPPER;
    const sageGreen = COLORS.SAGE_GREEN;
    const plum = COLORS.PLUM;
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const InfoCard = ({ icon, title, children }) => (
        <Card className="h-100 border-0 shadow-sm hover-shadow">
            <Card.Body className="p-4">
                <div className="text-center mb-4">
                    <div className="rounded-circle bg-light d-inline-flex p-3">
                        {icon}
                    </div>
                </div>
                <Card.Title className="text-center h5 mb-3" style={{ color: plum }}>{title}</Card.Title>
                <Card.Text className="text-muted">
                    {children}
                </Card.Text>
            </Card.Body>
        </Card>
    );

    return (
        <div className="bg-light min-vh-100 py-5">
            <Container>
                {/* Hero Section */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold mb-3" style={{ color: plum }}>
                            Terms & Conditions
                        </h1>
                        <p className="lead" style={{ color: copper }}>
                            Important information about our auction process and policies
                        </p>
                    </Col>
                </Row>

                {/* Main Content */}
                <Row className="g-4 mb-5">
                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaExclamationTriangle size={24} color={sageGreen} />}
                            title="Important Notices"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Live animals sold as-is</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> No gender guarantee</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> No fertility warranty</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> All sales are "Voetstoots"</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Seller's right to withdraw</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaMoneyBillWave size={24} color={sageGreen} />}
                            title="Payment Terms"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> <s>10% commission on successful bids</s> <strong>7.5% commission for 2025</strong></li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> No bids incur commission charge on Start Bid Price</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Payment within 7 days</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Commission deducted from payment</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> All prices in South African Rand</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaShieldAlt size={24} color={sageGreen} />}
                            title="Buyer Protection"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Secure payment processing</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Verified seller accounts</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Dispute resolution system</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Transaction monitoring</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Secure communication</li>
                            </ul>
                        </InfoCard>
                    </Col>
                </Row>

                {/* Additional Sections */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h2 className="h3 fw-bold mb-4" style={{ color: plum }}>
                            Auction Process Details
                        </h2>
                    </Col>
                </Row>

                <Row className="g-4 mb-5">
                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaClock size={24} color={sageGreen} />}
                            title="Auto-Extension System"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> 5-minute extension on last bid</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Continues until no new bids</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Prevents last-second sniping</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Fair chance for all bidders</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Server time is final</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaShieldAlt size={24} color={sageGreen} />}
                            title="Bid Protection"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Email bid confirmations</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Outbid notifications</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Bid tracking system</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Secure transactions</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Required documentation</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaExclamationTriangle size={24} color={sageGreen} />}
                            title="Legal Disclaimer"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Terms subject to change</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Platform rules apply</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> User responsibility</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Privacy policy compliance</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Legal jurisdiction</li>
                            </ul>
                        </InfoCard>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default TermsScreen; 